import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiFetch } from '@/lib/apiFetch'
import { cn } from '@/lib/utils'
import VoiceBadge from '@/components/VoiceBadge'
import type { Warmup } from '@/lib/types'

export default function StudioListPage() {
  const [warmups, setWarmups] = useState<Warmup[] | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    apiFetch<Warmup[]>('/warmups')
      .then(setWarmups)
      .catch((e) => setError(e.message))
  }, [])

  return (
    <div className="mx-auto max-w-5xl px-4 py-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="spec-label mb-2">The Studio</p>
          <h1 className="font-display text-3xl font-bold">Warm-up inventory</h1>
        </div>
        <div className="flex gap-2">
          <Link to="/studio/tags" className="inline-flex min-h-[44px] items-center rounded-full border px-5 font-medium">
            Manage tags
          </Link>
          <Link
            to="/studio/warmups/new"
            className="inline-flex min-h-[44px] items-center rounded-full bg-primary px-5 font-medium text-primary-foreground"
          >
            New warm-up
          </Link>
        </div>
      </div>

      {error && <p className="mt-6 text-destructive">{error}</p>}
      {!warmups && !error && <p className="mt-8 spec-label">Loading…</p>}

      {warmups && (
        <div className="mt-8 overflow-x-auto rounded-lg border bg-card">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-left">
                <th className="spec-label px-4 py-3">Name</th>
                <th className="spec-label px-4 py-3">Voice</th>
                <th className="spec-label px-4 py-3">Tags</th>
                <th className="spec-label px-4 py-3">Favorites</th>
                <th className="spec-label px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {warmups.map((w) => (
                <tr key={w.id} className="border-b last:border-0 hover:bg-secondary/50">
                  <td className="px-4 py-3">
                    <Link to={`/studio/warmups/${w.id}`} className="font-medium underline-offset-2 hover:underline">
                      {w.name}
                    </Link>
                  </td>
                  <td className="px-4 py-3"><VoiceBadge voice={w.voice} /></td>
                  <td className="px-4 py-3 text-muted-foreground">{w.tags.map((t) => t.name).join(', ')}</td>
                  <td className="px-4 py-3 font-mono">{w.favoriteCount}</td>
                  <td className="px-4 py-3">
                    <span
                      className={cn(
                        'rounded-full px-2 py-0.5 text-xs font-medium',
                        w.isActive ? 'bg-secondary text-secondary-foreground' : 'bg-muted text-muted-foreground'
                      )}
                    >
                      {w.isActive ? 'Active' : 'Retired'}
                    </span>
                  </td>
                </tr>
              ))}
              {warmups.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-4 py-10 text-center text-muted-foreground">
                    No warm-ups yet. Author the first one.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
